// Dependencies
import clsx from 'clsx';
import { isSameDay, isWeekend } from 'date-fns';
import React, { FC, ReactElement } from 'react';
// Core & Lab
import TableCell from '@mui/material/TableCell';
import { Box } from '@mui/system';
import { utcToZonedTime } from 'date-fns-tz';
import { useDispatch } from 'react-redux';
import { loadStockRoomProduct, updateStockRoomProductInfo } from './redux/reducer';

type ChannelManagerStockCalendarSoldCellProps = {
    room_id: number,
    stock_index: number,
    stock: any // TODO change type to real type
}

const ChannelManagerStockCalendarSoldCell: FC<ChannelManagerStockCalendarSoldCellProps> = ({ room_id, stock_index, stock }): ReactElement | null => {
    const dispatch = useDispatch();
    if (stock.id === null) {
        if (stock.price === null) {
            return <TableCell className={ clsx('ft-roomStockCell', { ['ft-roomStockCellWeekEnd']: isWeekend(new Date(stock.date)) }) }/>;
        } else {
            return <TableCell className={ clsx('ft-roomStockCell', { ['ft-roomStockCellWeekEnd']: isWeekend(new Date(stock.date)) }) } align={ 'center' }><Box sx={{ fontWeight: 'bold' }}>0</Box></TableCell>;
        }
    } else {
        let price_start_date = new Date(stock.price.start_date);
        const price_end_date = new Date(stock.price.end_date);
        let index = 0;
        while (price_start_date < stock.date && price_start_date <= price_end_date) {
            price_start_date = new Date(price_start_date.setDate(price_start_date.getDate() + 1));
            index++;
        }
        let real_stock:any = null;
        stock.price.real_stock?.forEach((_real_stock: any, id: any) => {
            if(isSameDay(utcToZonedTime(_real_stock.date + 'T00:00:00Z', 'Etc/UTC'), price_start_date)){
                real_stock = _real_stock;
            }
        });
        let stock_value = Math.abs(stock.quantity);
        if (stock.price.stocks !== undefined && stock.price.stocks !== null && index < stock.price.stocks.length && !isNaN(stock.price.stocks[index])) {
            stock_value = stock.price.stocks[index] - stock.quantity;
        }
        const showRoomProduct = () => {
            if(real_stock){
                dispatch(updateStockRoomProductInfo({  real_stock, price_id: stock.price.id }));
                dispatch(loadStockRoomProduct());
            }
        };
        return <TableCell className={ clsx('ft-roomStockCell', { ['ft-roomStockCellEdit']: !!real_stock }, { ['ft-roomStockCellWeekEnd']: isWeekend(new Date(stock.date)) }) } align={ 'center' }><Box sx={{ fontWeight: 'bold' }} onClick={ showRoomProduct }>{ stock_value }</Box></TableCell>;
    }
};

export default React.memo(ChannelManagerStockCalendarSoldCell);